export const MAX_PRO_CARD_LENGTH = 10000;
export const MAX_FREE_CARD_LENGTH = 1000;
export const MAX_FREE_STAFF_MEMBERS = 10;
export const MAX_PRO_STAFF_MEMBERS = 100;
